import axios from 'axios';
import Api from '../../../api/ApiUrl'

const API_URL = `${Api}/api/v1/deposite`;

const getDeposits = () => axios.get(API_URL);
const getAdminNotifications = () => axios.get(`${API_URL}/notifications/admin`);
const createDeposit = (deposit) => axios.post(API_URL, deposit);
const updateDeposit = (id, deposit) => axios.patch(`${API_URL}/${id}/approve`, deposit);
const updateDepositregected = (id, deposit) => axios.patch(`${API_URL}/${id}/reject`, deposit);
const deleteDeposit = (id) => axios.delete(`${API_URL}/${id}`);
const fetchDepositById = (id) => axios.get(`${API_URL}/${id}`);


export default {
  getDeposits,
  getAdminNotifications,
  createDeposit,
  updateDeposit,
  deleteDeposit,
  fetchDepositById,
  updateDepositregected
};
